import {useContext} from "react";
import {Link} from "react-router";

import logo from "@/assets/images/logo.svg";
import {NavBarContext} from "@/components/navBar/NavBar.utils.tsx";

import styles from "./NavBarLogo.module.scss";

export const NavBarLogo = () => {
  const {isMobile} = useContext(NavBarContext);
  return (
    <Link to={`/dashboard/`} className={isMobile ? styles.navBarLogoContainerMobile : styles.navBarLogoContainer}>
      <img className={styles.navBarLogo} src={logo} alt="Uptime.com" />
    </Link>
  );
};
